import useChartDateFormatter from '@Dashboard/RiskUser/useChartDateFormatter';
import { TimeRangeEnum } from '@Dashboard/TimeRangeSelector';
import { useUtcOffsetStore } from '@Models/useUtcOffsetModel';
import { useMemo } from 'react';
import { ECharts, EChartsProps } from 'src/ECharts';
import {
  dashboardHighRiskTrendsBarSeries,
  dashboardTimerangeXData,
} from 'src/ECharts/utils';

export interface HighRiskRecipientsProps extends EChartsProps {
  data: Record<string, Record<string, number>>;
  interval: string;
}

export const HighRiskRecipients = (props: HighRiskRecipientsProps) => {
  const { data: _data, interval, ...echartsProps } = props;
  const timeModel = useUtcOffsetStore();
  const { format } = useChartDateFormatter();

  const data = useMemo(() => _data ?? {}, [_data]);

  const series = useMemo(() => {
    const categories = Object.entries(data).map(([category]) => category);
    return categories.map((category) =>
      dashboardHighRiskTrendsBarSeries({
        data,
        category,
      })
    );
  }, [data]);

  const legendData = useMemo(() => {
    // Set legend data in the same order as series
    return series.map((item) => item.name as string);
  }, [series]);

  return (
    <ECharts
      series={series.reverse()}
      xAxis={{
        data: dashboardTimerangeXData(
          data[Object.keys(data)[0]],
          timeModel.offset
        ).map((timestamp) =>
          format({
            timestamp,
            interval: interval as TimeRangeEnum,
          })
        ),
        axisLabel: {
          rotate: 0,
        },
      }}
      grid={{ top: 20, right: 300, bottom: 40, left: 40 }}
      legend={{
        data: legendData,
        top: 'middle',
        orient: 'vertical',
        align: 'left',
        right: 125,
        textStyle: { overflow: 'truncate', width: 250, align: 'left' },
      }}
      height="220px"
      {...echartsProps}
    />
  );
};
